import React, { useState, useEffect, useRef } from "react";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Components
import LeadsBoard from './LeadsBoard';
import { Button, Section } from 'react-bulma-components';
import AddLeadPanel from "./AddLeadPanel";
import LeadDetailPanel from "./LeadDetailPanel";
import Loading from "shared/components/loading/Loading";


// actions
import { makeAPIRequest } from "shared/state/fetch";
import { useTokenStatus } from "shared/state/auth/actions";

// Styles
import styles from './Leads.module.scss';

const Leads = () => {
    const [leadsList, setLeadsList] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [addNewLead, setAddNewLead] = useState({ shouldAdd: false, stage: null });
    const [selectedLead, setSelectedLead] = useState(false);
    const { handleTokenStatus } = useTokenStatus();
    const isMounted = useRef(null);

    useEffect(() => {
        isMounted.current = true;
        makeAPIRequest('leads')
            .then(response => {
                if (isMounted.current) {
                    setIsLoading(false);
                    setLeadsList(groupByStages(response.result.data));
                    response.status && handleTokenStatus(response);
                }
            })
        return () => {
            // executed when unmount
            isMounted.current = false;
        }
    }, []); // empty dependency array means this effect will only run once

    const groupByStages = (arr) => {
        return arr && arr.length > 0 && arr.reduce((result, val) => {
            const stage = val["stages"];
            result[stage] = [...(result[stage] || []), val]
            return result;
        }, {});
    };

    const handleMoveLead = (updatedLead) => {
        const toStage = updatedLead.stage;
        const newLead = { ...updatedLead.item, stages: toStage };

        // remove item from current list
        leadsList[updatedLead.from]
            .splice(leadsList[updatedLead.from]
            .findIndex(el => el.id === updatedLead.id), 1);

        const newList = {...leadsList, [toStage]: [...(leadsList[toStage] || []), newLead]};

        makeAPIRequest(`leads/change-stage/${updatedLead.id}`, 'PUT', {stage:toStage })
            .then(response => {
                setLeadsList(newList);
                response.status && handleTokenStatus(response);
            })
    }

    const handleUpdateLead = (updatedLead) => {
        console.log(' handleOnSaveLead ', updatedLead);
        /*
        makeAPIRequest(`leads/${updatedLead.id}`, 'PUT', updatedLead)
            .then(response => {
                handleClose();
                //setLeadsList(groupByStages(response.result.data));
                response.status && handleTokenStatus(response);
            })
            */
    }

    // ADD
    const handleAddLeadClick = () => {
        setAddNewLead({ shouldAdd: true, stage: ''});
    }

    const handleAddLeadFromStage = (stage = '') => {
        setAddNewLead({ shouldAdd: true, stage: stage });
    }

    const handleOnAddNewLead = (newLead) => {
        makeAPIRequest('leads', 'POST', newLead)
            .then(response => {
                if(response.result) {
                    const result = response.result.data;
                    const newList = Object.assign( ...leadsList,{ [result.data.stages]: result.data });

                    setLeadsList(groupByStages(newList));
                    handleClose();
                }
                /*TODO: update global state with new lead */
                //setCurrentUser(response.result.data);
                //response.status && handleTokenStatus(response);
            }
        )
    }

    const handleClose = () => {
        setSelectedLead(false);
        setAddNewLead(false);
    }

    const handleOnSelectLead = (lead) => {
        setSelectedLead(lead);
    }


    return (
        <>
            { !isLoading &&
                <AddLeadPanel
                    isActive={ addNewLead.shouldAdd }
                    onAddNewLead={ handleOnAddNewLead }
                    onClose={ handleClose }
                    withStage={ addNewLead.stage } />
            }
            { !isLoading &&
                <LeadDetailPanel
                    isActive={ selectedLead }
                    lead={ selectedLead }
                    onSaveLead={ handleUpdateLead }
                    onClose={ handleClose } />
            }
            <Section style={{ height: '100%'}} className={ styles.leads }>
                <h1>Leads</h1>
                <Button className="gradient" size="small" onClick={ handleAddLeadClick }>
                    NEW LEAD
                </Button>
                <hr />
                { (!leadsList || Object.keys(leadsList).length === 0) && !isLoading && <p>No Leads to display</p> }
                { leadsList && Object.keys(leadsList).length > 0 &&
                    <DndProvider backend={HTML5Backend}>
                        <LeadsBoard
                            list={ leadsList }
                            onMoveLead={ handleMoveLead }
                            onAddLead={ handleAddLeadFromStage }
                            onSelectLead={ handleOnSelectLead } />
                    </DndProvider>
                }
            </Section>
            <Loading isLoading={ isLoading }/>
        </>
    );
}

export default Leads;
